import { getViaWebWorker } from '../store/api/API'
// const GHN_SLOT = {
//   DISTRICT: 'district',
//   WARD: 'ward'
// }
// // For cleaning ghn data
// const cleanData = (array) => {
//   array.forEach(c => {
//     delete c.name_with_type

//     c['quan-huyen'].forEach(d => {
//       delete d.parent_code
//       delete d.name_with_type

//       d['phuong-xa'].forEach(w => {
//         delete w.parent_code
//         delete w.name_with_type
//       })

//       d.ward = [...d['phuong-xa']]
//       delete d['phuong-xa']
//     })

//     c.district = [...c['quan-huyen']]
//     delete c['quan-huyen']
//   })

//   return array
// }

export const loadGHNData = async () => {
  const jsonFile = `/ghndata2.simple.json`
  return await getViaWebWorker(
    jsonFile,
    {},
    {
      baseURL: location.origin
    }
  )
}

export const getGHNIds = (geo_data, administrative) => {
  const city = administrative.find((e) => e.level === 2)
  const district = administrative.find((e) => e.level === 3)
  const ward = administrative.find((e) => e.level === 4)

  let ghnCity, ghnDistrict, ghnWard

  ghnCity = geo_data.find((c) => {
    if (city._id) {
      return c.code === city._id
    }
  })

  if (ghnCity) {
    ghnDistrict =
      ghnCity.district &&
      ghnCity.district.find((d) => {
        return d.code === district._id
      })

    if (ghnDistrict) {
      ghnWard =
        ghnDistrict.ward &&
        ghnDistrict.ward.find((d) => {
          return d.code === ward._id
        })
    }
  }

  return {
    city: ghnCity,
    district: ghnDistrict,
    ward: ghnWard
  }
}
